import { useState } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Spinner } from '~/components/ui/Spinner';
import { Text } from '~/components/ui/Text';
import { TextInput, TextInputAlign } from '~/components/ui/TextInput';
import { rage } from '~/rage';
import {
	StyledDescription,
	StyledPanel,
	StyledQuotes,
	StyledTitle,
} from './ClosedBeta.styled';

const ClosedBeta = () => {
	const [code, setCode] = useState('');
	const [loading, setLoading] = useState(false);

	const isActive = code.length > 0;

	const handleSubmit = async () => {
		if (loading || !isActive) {
			return;
		}

		setLoading(true);
		try {
			await rage.accounts.verifyClosedBetaCode(code);
		} catch {
			/* empty */
		} finally {
			setLoading(false);
		}
	};

	return (
		<StyledPanel>
			<StyledQuotes />
			<StyledTitle>CCDPlanet V - ЗБТ</StyledTitle>
			<StyledDescription>
				Добро пожаловать на ЗБТ CCDPlanet V!
				<br />
				Введите ниже код доступа для входа
			</StyledDescription>
			<TextInput
				type="password"
				autoComplete="off"
				height={50}
				fontSize={isActive ? 18 : 16}
				textAlign={TextInputAlign.Center}
				placeholderOpacity={0.5}
				active={isActive}
				activeBgColor="#FFFFFF"
				activeTextColor="#262628"
				value={code}
				placeholder="Введите код доступа"
				style={{ marginTop: 36 }}
				onChange={(event) => setCode(event.target.value)}
				onKeyDown={(event) => {
					if (event.key === 'Enter') {
						void handleSubmit();
					}
				}}
			/>
			<Button
				color={ButtonColors.Select}
				height={ButtonHeight.Height50}
				disabled={!isActive || loading}
				style={{ marginTop: 20, fontSize: 16 }}
				onClick={() => void handleSubmit()}
			>
				{loading ? (
					<Spinner />
				) : isActive ? (
					<Text style={{ fontWeight: 500 }}>Войти</Text>
				) : (
					<Text>Для продолжения введите код доступа</Text>
				)}
			</Button>
		</StyledPanel>
	);
};

export { ClosedBeta };
